import http from "../http";
import Service from "../../Service";

/**
 * Relatório de compras do cliente (kyojin GET /clients/reports/purchases).
 * Substitui o getprodutosrelatoriocliente da api legada.
 */
export default class PurchaseReportService extends Service {
    list(params) {
        return http.get("clients/reports/purchases", {
            headers: this.getHeaders(),
            params,
        });
    }

    options() {
        return http.get("clients/reports/purchases/options", {
            headers: this.getHeaders(),
        });
    }

    export(params) {
        return http.get("clients/reports/purchases", {
            headers: this.getHeaders(),
            params: { ...params, export: "xlsx" },
            responseType: "blob",
        });
    }
}
